import script from "./DragCarrousel.vue?vue&type=script&setup=true&lang=js"
export * from "./DragCarrousel.vue?vue&type=script&setup=true&lang=js"

import "./DragCarrousel.vue?vue&type=style&index=0&id=10663094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10663094"]])

export default __exports__